module.exports = __webpack_public_path__ + "img/green_031.963d68ef.png";